import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { RefundPurchaseResponse } from './types';

type RefundMemberPurchaseParams = {
  memberId: string;
  purchaseId: string;
};

export async function refundMemberPurchase({ memberId, purchaseId }: RefundMemberPurchaseParams) {
  const url = `/web/studio/users/${memberId}/purchases/${purchaseId}/refund`;

  const response = await api.executePostRequest<ObjectResponse<RefundPurchaseResponse>>(url, {});

  return response.data;
}
